import useFunctions from "@/composables/useFunctions";

const { deleteDifferenceTimezone } = useFunctions()
// export const myMutation = ( state ) => {

// }

export const setEvidences = ( state, evidences ) => {
    evidences.forEach(evidence => {
        evidence.weekStart = evidence.weekStart == null ? null : deleteDifferenceTimezone(new Date(evidence.weekStart))
        evidence.weekEndDate = evidence.weekEndDate == null ? null : deleteDifferenceTimezone(new Date(evidence.weekEndDate))
        evidence.filesOnUpload = []
    })
    state.evidences = evidences
}

export const updateEvidences = ( state, { evidences, file } ) => {
    state.evidences.filter(evidence => evidence.id == evidences.hfsUser_id)[0].evidencias = [ {
        extension: evidences.extension,
        horaCargue: evidences.horaCargue,
        id: evidences.id,
        nombre: evidences.nombre,
        ruta: evidences.ruta,
        descripcion: evidences.descripcion,
    }, ...state.evidences.filter(evidence => evidence.id == evidences.hfsUser_id)[0].evidencias]

    state.evidences.filter(evidence => evidence.id == evidences.hfsUser_id)[0].filesOnUpload = [...state.evidences.filter(evidence => evidence.id == evidences.hfsUser_id)[0].filesOnUpload.filter(fileOnUpload => fileOnUpload !== file)]
}

export const removeFileOnUpload = ( state, { file, idWeek } ) => {
    state.evidences.filter(evidence => evidence.id == idWeek)[0].filesOnUpload = [...state.evidences.filter(evidence => evidence.id == idWeek)[0].filesOnUpload.filter(fileOnUpload => fileOnUpload !== file)]
}

export const deleteFileUpload = ( state, { idFile, idHfsUser } ) => {
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].evidencias = [...state.evidences.filter(evidence => evidence.id == idHfsUser)[0].evidencias.filter(fileUpload => fileUpload.id !== idFile)]
}

export const saveHfsUser = ( state, { description, idHfsUser, hfsUser }) => {
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].description = description
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].horaEnvioSemana = hfsUser.horaEnvioSemana
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].observacion = null
}

export const cancelHfsUser = ( state, { idHfsUser, hfsUser }) => {
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].horaEnvioSemana = hfsUser.horaEnvioSemana
}

export const approveWeek = ( state, { idHfsUser, hfsUser }) => {
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].aval = hfsUser.aval
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].horaAval = hfsUser.horaAval
}

export const disapproveWeek = ( state, { idHfsUser, hfsUser }) => {
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].aval = hfsUser.aval
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].observacion = hfsUser.observacion
    state.evidences.filter(evidence => evidence.id == idHfsUser)[0].horaAval = hfsUser.horaAval
}